function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Bitstream Vera Sans"
    },
    d: "M 28.28125 6.28125 L 11 23.5625 L 3.71875 16.28125 L 2.28125 17.71875 L 10.28125 25.71875 L 11 26.40625 L 11.71875 25.71875 L 29.71875 7.71875 L 28.28125 6.28125 z",
    color: "#000",
    overflow: "visible",
    fontFamily: "Bitstream Vera Sans"
  }));
};

export default __webpack_public_path__ + "static/media/checkmark.798be02f.svg";
export { SvgComponent as ReactComponent };